<template>
  <section
    v-if="playInfo && playInfo.length > 0"
    class="module dt-episode"
  >
    <h3>
      选集
      <span
        v-if="item.finished === '1' || updatedEpisode === finishEpisode"
        v-show="finishEpisode !== '0'"
      >
        共{{ finishEpisode }}集
      </span>
      <span v-else-if="finishEpisode && finishEpisode !== '0'">
        更新至第{{ updatedEpisode }}集/共{{ finishEpisode }}集
      </span>
      <span v-else> 更新至第{{ updatedEpisode }}集 </span>
    </h3>
    <div class="dt-episode-wrap">
      <div
        v-if="updatedEpisode > 15"
        class="dt-episode-choose"
      >
        <select v-model="selected">
          <option
            v-for="(list, index) in playInfo"
            :key="index"
            :value="index"
            :uigs="'eposide_nav_' + playIndexInfo + '-' + index"
          >
            {{ optionVal(list) }}
          </option>
        </select>
      </div>
      <ul class="dt-episode-list">
        <li
          v-for="(i, index) in playInfo[selected]"
          :key="index"
          :class="{ disabled: i.s === 0 }"
        >
          <template v-if="i.s === 0">
            <span
              class="item-button"
              :uigs="'play_' + i.index"
            >{{ i.index }}</span>
          </template>
          <template v-else>
            <a
              :href="i.url"
              :uigs="'play_' + i.index"
              :uigsparams="`play_type=lvideo&play_url=${encodeURIComponent(i.url)}&play_site=${site}`"
            >{{ i.index }}</a>
            <span
              v-if="i.s === 3"
              class="tag-pre"
            >预</span>
            <span
              v-if="i.s === 2"
              class="tag-vip"
            >VIP</span>
          </template>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

import * as types from '../../../store/mutaion-types';

export default {
  data() {
    return {
      playIndexInfo: 0,
      selected: 0,
      finishEpisode: '',
      updatedEpisode: '',
      site: '',
    };
  },
  computed: {
    ...mapState('detail', ['itemData', 'playInfoIndex']),
    dockey() {
      return this.itemData.dockey;
    },
    item() {
      return this.itemData;
    },
    playInfo() {
      const self = this;
      const newArray = [];
      const item = self.itemData;
      self.playIndexInfo = self.playInfoIndex;

      if (item.ipad_play) {
        const playInfo = item.ipad_play.item_list;
        if (playInfo && playInfo.length > 0) {
          const showInfo = playInfo[self.playIndexInfo];
          self.finishEpisode = showInfo.finish_episode;
          self.site = showInfo.site;
          self[types.UPDATE_FINISH_EPISODE](showInfo.finish_episode);

          if (showInfo && showInfo.info) {
            self.updatedEpisode = showInfo.info.length - 1;
            let index = 0;
            const sublength = 15;
            let arr = showInfo.info.slice(1, showInfo.info.length);
            if (item.finished && item.finished !== '1' && self.updatedEpisode !== self.finishEpisode) {
              arr = arr.reverse();
            }
            while (index < arr.length) {
              newArray.push(arr.slice(index, (index += sublength)));
            }
          }
        }
      }

      return newArray;
    },
  },
  watch: {
    playInfoIndex(newV, oldV) {
      if (newV !== oldV) {
        this.selected = 0;
      }
    },
  },
  mounted() {
    // 兼容跳转出在回退，更新select选项值
    const timer = setTimeout(() => {
      const a = document.querySelectorAll('select option');
      a.length && (a[0].selected = true);
      clearTimeout(timer);
    }, 0);
  },
  methods: {
    ...mapMutations('detail', [types.UPDATE_FINISH_EPISODE]),
    optionVal(list) {
      if (list.length === 1) {
        return `第${list[0].index}集`;
      }
      return `第${list[0].index}-${list[list.length - 1].index}集`;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';
.dt-episode {
  margin-bottom: 18px !important;
}
.dt-epitasis-detail-list {
  padding: 0 14px;

  > a {
    display: block;
    height: 65px;
    margin-bottom: 15px;
    position: relative;

    .img {
      width: 115px;
      height: 65px;
      border-radius: 5px;
      overflow: hidden;
      float: left;
      margin-right: 10px;
      position: relative;

      &:before {
        content: '';
        width: 100%;
        height: 50px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .tag-time {
      color: #fff;
      font-size: 13px;
      position: absolute;
      right: 6px;
      bottom: 6px;
    }

    .info {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        &:nth-of-type(1) {
          @include line-clip(2);
          line-height: 22px;
          color: #222;
          font-size: 15px;
          margin-bottom: 10px;
        }

        &:nth-of-type(2) {
          @include line-clip(1);
          color: #999;
          font-size: 13px;
        }
      }
    }
  }
}

.dt-episode-wrap {
  padding: 0 14px;
  margin-bottom: 30px;
}

.dt-episode-list {
  font-size: 0;

  li {
    display: inline-block;
    width: 18%;
    margin-right: 2.5%;
    margin-bottom: 2.5%;
    height: 50px;
    border-radius: 3px;
    background: #f5f5f5;
    font-size: 15px;
    position: relative;

    &:nth-child(5n) {
      margin-right: 0;
    }

    &.disabled {
      opacity: 0.5;
      .item-button {
        color: #999;
      }
    }
  }

  a,
  .item-button {
    color: #000;
    text-align: center;
    display: block;
    width: 100%;
    height: 100%;
    line-height: 50px;
  }

  .tag-vip {
    position: absolute;
    padding: 2px 5px;
    border-radius: 3px;
    background: linear-gradient(to bottom, #ff8e33, #ff7219);
    font-size: 11px;
    color: #fff;
    font-weight: bold;
    right: 0;
    top: 0;
  }

  .tag-pre {
    position: absolute;
    padding: 2px 3px;
    border-radius: 3px;
    background: #999;
    font-size: 11px;
    color: #fff;
    font-weight: bold;
    right: 0;
    top: 0;
  }
}

.dt-episode-choose {
  width: 100%;
  margin-bottom: 15px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  border-radius: 3px;
  font-size: 13px;
  color: #222;
  border: 1px solid #ccc;
  position: relative;

  &:after {
    content: '';
    @include arr(6px, 135deg, #555);
    @extend %-vertical-center;
    right: 20px;
  }

  select {
    padding-left: 12px;
    width: 100%;
    height: 100%;
    font-size: 15px;
  }

  option {
    padding-left: 12px;
    width: 100%;
    height: 100%;
  }
}
</style>
